<template>
    <el-tree
        ref="area_tree"
        node-key="id"
        :data="props.sourceData"
        :props="defaultProps"
        @node-click="handleNodeClick"
        highlight-current
        :expand-on-click-node="false"
        :draggable="draggable"
        :default-expanded-keys="expandedKey"
        @node-drag-start="handleDragStart"
        @node-drag-enter="handleDragEnter"
        @node-drag-leave="handleDragLeave"
        @node-drag-over="handleDragOver"
        @node-drag-end="handleDragEnd"
        @node-drop="handleDrop"
        :allow-drop="allowDrop"
        :allow-drag="allowDrag"
    >
        <template #default="scope">
            <div class="custom-node">
                <span style="font-size: 14px">{{ scope.node.label }}</span>
            </div>
        </template>
    </el-tree>
</template>

<script setup>
import { defineEmits, defineProps, nextTick, reactive, ref, watch } from 'vue'

const props = defineProps({
    // 数据源
    sourceData: {
        type: Array,
        required: true
    },
    // 已选节点
    currentNodeKey: {
        type: String,
        required: false
    },
    draggable: {
        type: Boolean,
        required: false
    }
})
const defaultProps = reactive({
    children: 'children',
    label: 'name'
})
// tree实例
const area_tree = ref(null)

const emits = defineEmits(['handleNodeClick', 'updateSort'])

const expandedKey = ref([])
const handleNodeClick = (node, treeNode) => {
    emits('handleNodeClick', { node, treeNode })
}
const handleDragStart = (node, ev) => {
    // console.log('drag start', node)
}

const handleDragEnter = (draggingNode, dropNode, ev) => {
    // console.log('tree drag enter:', dropNode.label)
}

const handleDragLeave = (draggingNode, dropNode, ev) => {
    // console.log('tree drag leave:', dropNode.label)
}

const handleDragOver = (draggingNode, dropNode, ev) => {
    // console.log('tree drag over:', dropNode.label)
}

const handleDragEnd = (draggingNode, dropNode, dropType, ev) => {
    // console.log('tree drag end:', dropNode && dropNode.label, dropType)
}
const handleDrop = (draggingNode, dropNode, dropType, ev) => {
    const newOrder = [...props.sourceData]
    emits('updateSort', newOrder)
}

const allowDrop = (draggingNode, dropNode, type) => {
    // 只可同级拖动 不可拖动到更节点
    if (type === 'inner' || dropNode.level === 1) {
        return false
    } else {
        return true
    }
}
const allowDrag = (draggingNode) => {
    return true
}

watch(
    () => props.sourceData,
    (newVal) => {
        if (newVal.length) {
            expandedKey.value = [props.sourceData[0].id]
        }
        if (newVal && props.currentNodeKey) {
            /**
             * 列表跟新 保持已选的节点高亮
             */
            nextTick(() => {
                area_tree.value.setCurrentKey(props.currentNodeKey)
            })
        }
    }
)
</script>

<style></style>
